import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auto-login',
  template: `<p>auto-login works!</p>`
})
export class AutoLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
